import React, {useCallback, useState} from 'react';
import SelectedCover from "../SelectedCover";
import Gallery from "react-photo-gallery";
import styles from './CoverPreviewContainer.module.scss'
import {CoverPreview} from "../CoverPreview/CoverPreview";
import {Modal} from "antd";
import ReactPlayer from "react-player";

import {useAppDispatch} from '../../../../hooks';
import {setCurrentIndex, setImages, show} from '../../../../features/lightbox/lightboxSlice';

interface CoverPreviewContainerProps {
    covers: any[]
    columns: number
    maxSize: number
}

export const CoverPreviewContainer: React.FunctionComponent<CoverPreviewContainerProps> = (props) => {
    const [selectedAll, setSelectedAll] = useState<boolean>(false);
    const [viewerIsOpen, setViewerIsOpen] = useState<boolean>(false);
    const [openVideo, setOpenVideo] = useState<boolean>(false);
    const [photoIndex, setPhotoIndex] = useState<number>(0);

    const dispatch = useAppDispatch();

    const imageRenderer = useCallback(
        ({index, left, top, key, photo}) => (
            <SelectedCover
                selected={selectedAll}
                key={key}
                margin={"2px"}
                index={index}
                photo={photo}
                left={left}
                top={top}
            />
        ),
        [selectedAll]
    );

    const handleOpenPhoto = (photo: any, index: number) => {
        // setViewerIsOpen(true);
        dispatch(show())
        dispatch(setImages(props.covers.filter((c: any) => c.type === "image").map(x => ({
            ...x,
            // srcset: x.srcSet,
            // caption: x.title
        }))))
        let filterIndex = props.covers.filter((c: any) => c.type === "image").findIndex((c: any) => c.id === photo.id);
        setPhotoIndex(filterIndex === -1 ? 0 : filterIndex);
        dispatch(setCurrentIndex(filterIndex === -1 ? 0 : filterIndex))
        // let filterIndex = props.covers.filter((c: any) => c.type === "image").findIndex((c: any) => c.id === photo.id);
        // setPhotoIndex(filterIndex === -1 ? 0 : filterIndex);
    }

    const handleOpenVideo = (photo: any, index: number) => {
        setViewerIsOpen(false);
        setPhotoIndex(index);
        setOpenVideo(true)
    }

    const imageRender = useCallback(
        ({index, left, top, key, photo}) => {
            // const sx = (100 - (30 / photo.width) * 100) / 100;
            // const sy = (100 - (30 / photo.height) * 100) / 100;
            // selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;
            return <CoverPreview
                key={key}
                photo={photo}
                left={left}
                top={top}
                onClickImg={() => handleOpenPhoto(photo, index)}
                onClickVideo={() => handleOpenVideo(photo, index)}
                isLast={index === props.maxSize - 1}
                overflow={props.covers.length > props.maxSize}
                overflowSize={props.covers.length - props.maxSize}
            />
            // return <img
            //     alt={photo.title}
            //     onLoad={(e) => {
            //         //@ts-ignore
            //         console.log("imageLoaded", e.currentTarget.width);
            //     }}
            //     style={{
            //         objectFit: "cover",
            //         left: left,
            //         top: top,
            //         objectPosition: "100% 50%",
            //         // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
            //         // margin: "2px",
            //         display: "block",
            //         position: "absolute",
            //         cursor: "pointer",
            //         ...photo?.style
            //     }}
            //     src={photo.src}
            //     width={photo.width}
            //     height={photo.height}
            //     onClick={() => setViewerIsOpen(true)}
            // />
        },
        [selectedAll]
    );

    return (
        <div>
            <Gallery
                direction={"column"}
                // targetRowHeight={2}
                columns={props?.columns}
                photos={props?.covers ? props?.covers?.slice(0, props.maxSize) : []}
                // onClick={() => setViewerIsOpen(true)}
                // renderImage={imageRenderer}
                renderImage={imageRender}
            />
            {/*<Lightbox*/}
            {/*    open={viewerIsOpen}*/}
            {/*    close={() => setViewerIsOpen(false)}*/}
            {/*    slides={[*/}
            {/*        // ...[*/}
            {/*        //     {*/}
            {/*        //         type: "video",*/}
            {/*        //         width: 1280,*/}
            {/*        //         height: 720,*/}
            {/*        //         poster: "/public/poster-image.jpg",*/}
            {/*        //         sources: [*/}
            {/*        //             {*/}
            {/*        //                 src: "/public/video.mp4",*/}
            {/*        //                 type: "video/mp4"*/}
            {/*        //             }*/}
            {/*        //         ]*/}
            {/*        //     }*/}
            {/*        // ],*/}
            {/*        // ...slides*/}
            {/*    ]}*/}
            {/*    plugins={[Video]}*/}
            {/*/>*/}
            {/*<ModalGateway>*/}
            {/*    {viewerIsOpen && (*/}
            {/*        <ImageModal onClose={() => setViewerIsOpen(false)}>*/}
            {/*            <Carousel*/}
            {/*                currentIndex={photoIndex}*/}
            {/*                views={props.covers.filter((c: any) => c.type === "image").map(x => ({*/}
            {/*                    ...x,*/}
            {/*                    // srcset: x.srcSet,*/}
            {/*                    // caption: x.title*/}
            {/*                }))}*/}
            {/*                // views={props.covers}*/}
            {/*            />*/}
            {/*        </ImageModal>*/}
            {/*    )}*/}
            {/*</ModalGateway>*/}
            {openVideo && (
                <Modal
                    centered
                    className={styles.modalOveride}
                    open={true}
                    footer={null}
                    onCancel={() => setOpenVideo(false)}
                >
                    <div
                        style={{ width: "100%" }}
                        // onClick={handleClickVideoModal}
                    >
                        <ReactPlayer
                            playing
                            // onReady={videAudioOnReady}
                            controls={true}
                            className={styles.reactPlayer}
                            url={props.covers[photoIndex].src}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
}